var React = require('react');

function Findme (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_35943","data-name":"Rectangle 35943","width":"50","height":"50","rx":"25","fill":"#fff","key":0}),React.createElement("g",{"id":"crosshair-m","transform":"translate(13 13)","key":1},[React.createElement("path",{"id":"Path_104230","data-name":"Path 104230","d":"M12,10.5A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z","key":0}),React.createElement("path",{"id":"Path_104231","data-name":"Path 104231","d":"M13,2V4.062A8,8,0,0,1,19.938,11H22v2H19.938A8,8,0,0,1,13,19.938V22H11V19.938A8,8,0,0,1,4.062,13H2V11H4.062A8,8,0,0,1,11,4.062V2ZM6.083,13H8V11H6.083A6.005,6.005,0,0,1,11,6.083V8h2V6.083A6.005,6.005,0,0,1,17.917,11H16v2h1.917A6.005,6.005,0,0,1,13,17.917V16H11v1.917A6.005,6.005,0,0,1,6.083,13Z","fillRule":"evenodd","key":1})])]);
}

Findme.defaultProps = {"id":"findme","width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Findme;

Findme.default = Findme;
